import React, {useEffect, useState} from 'react';
import Dialog from "@material-ui/core/Dialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import {compose} from "redux";
import {connect} from "react-redux";
import {updateClient} from "../../redux/reducers/user";
import {DOCUMENT_CATEGORIES, purposeMapping} from "../../config/constants";
import * as _ from 'lodash';
import {humanFileSize} from "../../utils/helpers";
import * as moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";
import routes from "../../utils/api-client";

function ClientDocumentsModal(props){

  let [tempDocuments, setTempDocuments] = useState([]);
  let [documentCategories, setDocumentCategories] = useState([]);

  useEffect(() => {
    const docNames = _.map(props.documents, 'name');
    const categories = _.map(props.documentCategories, (category) => {
      _.forEach(category.documents, doc => {doc.used = _.includes(docNames, doc.name); console.log(doc)})
      return category;
    })
    setDocumentCategories(categories)
  }, [props.documents]);

  const updateTempDocuments = (document) => {
    let newDocuments = [...tempDocuments];
    const index = _.findIndex(newDocuments, doc => doc.name === document.name);
    if (index !== -1) {
      newDocuments.splice(index, 1);
    } else {
      newDocuments.push(document);
    }
    setTempDocuments(newDocuments)
  }

  const closeModal = () => {
    props.toggleModal();
  }

  return (
    <Dialog open={props.open} onClose={closeModal} fullWidth={true} maxWidth={"sm"} className={"client-documents-modal"}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center">
          <p className="text-lg sm:text-2xl font-bold">Choose Client Documents</p>
        </div>
        <FontAwesomeIcon icon="times" size="lg" className="text-grey cursor-pointer hidden sm:block" onClick={closeModal}/>
      </div>
      <Divider/>
      <div className="my-5 text-sm sm:text-base">
        {
          _.map(documentCategories, category =>
          <div className="document-category-container mb-3">
            <p className="text-lg font-bold">{DOCUMENT_CATEGORIES[category.type].title}</p>
            {
              category.documents.length && _.filter(category.documents, ['used', false]).length ?
                <div className="mt-2 mb-6" key={category.type}>
                  {
                    _.map(_.filter(category.documents, ['used', false]), (document, index) =>
                      <div key={document.name}
                        className={`document-button w-full`}>
                        <div className="flex justify-between items-center w-full text-left">
                          <Checkbox color="primary" value={_.filter(tempDocuments, ['name', document.name]).length} onChange={() => updateTempDocuments(document)}/>
                          <div className="sm:flex-1 sm:flex sm:items-center ml-4">
                            <p className="text-lg">{document.name}</p>
                            <span className="text-sm text-grey ml-2 hidden sm:inline">({ humanFileSize(document.size) })</span>
                          </div>
                        </div>
                      </div>
                    )
                  }
                </div> :
                <p className="text-grey mt-3 mb-6 ml-2">No documents found.</p>
            }
          </div>)
        }
      </div>
      <Divider/>
      <div className="flex justify-end mt-3">
        <div className="mr-3">
          <Button
            variant="outlined"
            onClick={closeModal}>Cancel</Button>
        </div>
        <div>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {props.updateDocuments(tempDocuments); setTempDocuments([]); closeModal();}}>Continue</Button>
        </div>
      </div>
    </Dialog>
  );
}


export default compose(
  connect(
    null,
    { updateClient }
  )
)(ClientDocumentsModal);
